export default __webpack_public_path__ + "media/images/autodealer-new-logo-6f94941dd0ab0b47daa06c1625d05322.png";